import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AdminPlaceDto, PlaceCreateInput, PlaceUpdateInput } from '@upme/contracts';
import { api } from '../../../app/api-client';
import { placeByIdOptions } from './places.queries';

export function useCreatePlace() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: PlaceCreateInput) => api.post('admin/places', { json: input }).json<AdminPlaceDto>(),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['admin', 'places'] }),
  });
}

export function useUpdatePlace(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: PlaceUpdateInput) =>
      api.patch(`admin/places/${id}`, { json: input }).json<AdminPlaceDto>(),
    onSuccess: (data) => {
      qc.setQueryData(placeByIdOptions(id).queryKey, data);
      qc.invalidateQueries({ queryKey: ['admin', 'places'] });
    },
  });
}

export function useDeletePlace() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.delete(`admin/places/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['admin', 'places'] }),
  });
}
